export { DetailsNavigation } from './DetailsNavigation';
export { FullDescription } from './FullDescription';
export { ReviewsSection } from './ReviewsSection';
export { PaymentMethodsModal } from './PaymentMethodsModal';
export { PriceTag } from './PriceTag';
export { YoutubePlayer } from './YoutubePlayer';
